import LogOutIcon from '@src/svgs/LogOutIcon';
import { memo, type ReactNode, useState } from 'react';
import styled, { css } from 'styled-components';

type OrganizationAvatarTooltipProps = {
  email?: string;
  onLogOut: () => void;
  topChildren?: ReactNode;
  bottomChildren?: ReactNode;
};

function OrganizationAvatarTooltip({
  onLogOut,
  email,
  topChildren,
  bottomChildren,
}: OrganizationAvatarTooltipProps) {
  const [logOutHover, setLogOutHover] = useState(false);
  return (
    <Wrapper>
      {topChildren}
      <Section
        clickable
        onClick={() => onLogOut()}
        onMouseEnter={() => setLogOutHover(true)}
        onMouseLeave={() => setLogOutHover(false)}
      >
        <LogOutIcon fillColor={logOutHover ? '#17c964' : undefined} />
        <SectionText color={logOutHover ? '#17c964' : undefined}>
          Log Out
        </SectionText>
      </Section>
      {email && (
        <Section>
          <EmailSectionText>{email}</EmailSectionText>
        </Section>
      )}
      {bottomChildren}
    </Wrapper>
  );
}

export default memo(OrganizationAvatarTooltip);

export const Wrapper = styled.div`
  display: inline-flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  border-radius: 8px;
  border: 1px solid #484848;
  background: #03041a;
  box-shadow: 8px 16px 8px 0px rgba(0, 0, 0, 0.4);

  width: 185px;
`;

export const Section = styled.div<{ clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  ${props =>
    props.clickable &&
    css`
      cursor: pointer;
    `}
`;

export const SectionText = styled.div<{ color?: string }>`
  color: ${props => props.color || '#F3E9D7'};
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const EmailSectionText = styled(SectionText)`
  color: #848484;
  font-size: 10px;
  font-weight: 400;
  margin-left: 24px; /* icon width (16) + gap (8px) */
  word-break: break-word;
`;
